import React, { useState } from 'react';
import Footer from '../../components/footer/index';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';
import { Search, Filter, X, ChevronLeft, ChevronRight } from 'lucide-react';

const GalleryPage = () => {
  const { isDarkMode } = useDarkMode();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Data kategori gallery - Update count
  const categories = [
    { id: 'all', name: 'Semua Foto', count: 15 },
    { id: 'installation', name: 'Proses Instalasi', count: 3 },
    { id: 'team', name: 'Tim Kami', count: 5 },
    { id: 'projects', name: 'Proyek Selesai', count: 4 },
    { id: 'equipment', name: 'Peralatan', count: 2 },
    { id: 'office', name: 'Kantor & Fasilitas', count: 1 }
  ];

  // Data gambar gallery - kategori diperbaiki
  const galleryImages = [
    { id: 1, src: "/image/Gallery/profil1.jpg", category: "office", title: "Kantor" },
    { id: 2, src: "/image/Gallery/profil2.jpg", category: "projects", title: "Depot Catekeeper Batam" },
    { id: 3, src: "/image/Gallery/profil3.jpg", category: "projects", title: "Pemantauan atau Inspeksi Proyek" },
    { id: 4, src: "/image/Gallery/profil4.jpg", category: "installation", title: "Aktivitas Teknis di Lapangan" },
    { id: 5, src: "/image/Gallery/profil5.jpg", category: "installation", title: "Operasi Lapangan" },
    { id: 6, src: "/image/Gallery/profil6.jpg", category: "team", title: "Teknisi Lapangan" },
    { id: 7, src: "/image/Gallery/profil7.jpg", category: "team", title: "Rapat Tim" },
    { id: 8, src: "/image/Gallery/profil9.jpg", category: "team", title: "Teknisi Lapangan" },
    { id: 9, src: "/image/Gallery/profil10.jpg", category: "projects", title: "Operasi Industri" },
    { id: 10, src: "/image/Gallery/profil11.jpg", category: "installation", title: "Konstruksi Lapangan" },
    { id: 11, src: "/image/Gallery/profil12.jpg", category: "team", title: "Briefing Lapangan" },
    { id: 12, src: "/image/Gallery/profil13.jpg", category: "equipment", title: "Pekerjaan di Ketinggian dan Inspeksi Fasilitas" },
    { id: 13, src: "/image/Gallery/profil14.jpg", category: "equipment", title: "Penggalian untuk Pondasi" },
    { id: 14, src: "/image/Gallery/profil15.jpg", category: "team", title: "Kunjungan atau Pertemuan Instansi Pemerintah" },
    { id: 15, src: "/image/Gallery/profil16.jpg", category: "team", title: "Pekerjaan Lapangan dan Kolaborasi Tim" }
  ];

  // Filter gambar berdasarkan kategori dan pencarian
  const filteredImages = galleryImages.filter(image => {
    const matchesCategory = selectedCategory === 'all' || image.category === selectedCategory;
    const matchesSearch = image.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Buka lightbox
  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  // Tutup lightbox
  const closeLightbox = () => {
    setSelectedImage(null);
  };

  // Navigasi gambar di lightbox
  const navigateImage = (direction) => {
    let newIndex;
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    }
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  // Download gambar
  const downloadImage = (imageSrc, imageTitle) => {
    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = `${imageTitle.replace(/\s+/g, '-').toLowerCase()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Close lightbox ketika klik di backdrop
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeLightbox();
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDarkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'}`}>
      {/* Hero Section */}
      <section className={`pt-20 py-20 px-4 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="container mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Gallery <span className="text-[#1E9B4C]">Perusahaan</span>
          </h1>
          <p className={`text-xl max-w-2xl mx-auto ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Dokumentasi kegiatan, proyek, dan momen penting perusahaan
          </p>
        </div>
      </section>

      {/* Filter & Search Section */}
      <section className={`py-8 px-4 sticky top-0 z-40 ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-sm`}>
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row gap-4 justify-between items-center">
            {/* Search Bar */}
            <div className={`relative flex-1 max-w-md ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
              <input
                type="text"
                placeholder="Cari foto..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={`w-full pl-10 pr-4 py-3 rounded-lg border transition-colors ${
                  isDarkMode 
                    ? 'bg-gray-700 border-gray-600 placeholder-gray-400 focus:border-[#1E9B4C]' 
                    : 'bg-white border-gray-300 placeholder-gray-500 focus:border-[#1E9B4C]'
                } focus:outline-none focus:ring-2 focus:ring-[#1E9B4C]/20`}
              />
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map(category => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                    selectedCategory === category.id
                      ? 'bg-[#1E9B4C] text-white shadow-lg'
                      : isDarkMode
                      ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {category.name} ({category.count})
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 px-4">
        <div className="container mx-auto">
          {filteredImages.length === 0 ? (
            <div className="text-center py-16">
              <div className={`text-6xl mb-4 ${isDarkMode ? 'text-gray-600' : 'text-gray-300'}`}>📷</div>
              <h3 className={`text-xl font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                Foto tidak ditemukan
              </h3>
              <p className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
                Coba gunakan kata kunci lain atau pilih kategori berbeda
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {filteredImages.map((image, index) => (
                <div
                  key={image.id}
                  className={`group relative overflow-hidden rounded-xl shadow-lg cursor-pointer transform transition-all duration-300 hover:scale-105 ${
                    isDarkMode ? 'bg-gray-800' : 'bg-white'
                  }`}
                  onClick={() => openLightbox(image, index)}
                >
                  <div className="aspect-square overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4`}>
                    <h3 className="text-white font-semibold text-sm">
                      {image.title}
                    </h3>
                  </div>
                  <div className={`absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                    isDarkMode ? 'bg-gray-800/80' : 'bg-white/80'
                  } rounded-full p-2`}>
                    <Search className={`w-4 h-4 ${isDarkMode ? 'text-white' : 'text-gray-700'}`} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal - DIPERBAIKI */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={handleBackdropClick}
        >
          <div className="relative max-w-6xl max-h-full w-full">
            {/* Close Button - DIPERBAIKI POSISINYA */}
            <button
              onClick={closeLightbox}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10 bg-black/50 rounded-full p-2"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Navigation Buttons */}
            <button
              onClick={() => navigateImage('prev')}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10 bg-black/50 rounded-full p-3"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>

            <button
              onClick={() => navigateImage('next')}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10 bg-black/50 rounded-full p-3"
            >
              <ChevronRight className="w-6 h-6" />
            </button>

            {/* Image */}
            <div className="relative flex justify-center">
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="max-w-full max-h-[80vh] object-contain rounded-lg"
              />
              
              {/* Image Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <div>
                    <h3 className="text-white font-semibold text-lg">
                      {selectedImage.title}
                    </h3>
                    <p className="text-gray-300 text-sm capitalize">
                      {categories.find(cat => cat.id === selectedImage.category)?.name}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => downloadImage(selectedImage.src, selectedImage.title)}
                      className="bg-[#1E9B4C] hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm"
                    >
                      Download
                    </button>
                    <button
                      onClick={closeLightbox}
                      className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm"
                    >
                      Tutup
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Image Counter */}
            <div className="text-white text-center mt-4">
              {currentIndex + 1} / {filteredImages.length}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;